import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatToolbarModule} from '@angular/material/toolbar';

import {FuseSearchBarModule, FuseShortcutsModule} from '@fuse/components';
import {FuseSharedModule} from '@fuse/shared.module';

import {ToolbarComponent} from 'app/layout/components/toolbar/toolbar.component';
import {UtilsModule} from '../../../utils/utils.module';
import {CookieService} from 'ngx-cookie-service';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { NotificationDialogComponent } from './notification-dialog/notification-dialog.component';
import { NgxPermissionsModule } from 'ngx-permissions';
import {SharedModule} from '../../../shared/shared.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { EnvironmentButtonComponent } from './environment-button/environment-button.component';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

@NgModule({
  declarations: [
    ToolbarComponent,
    NotificationDialogComponent,
    EnvironmentButtonComponent
  ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        MatToolbarModule,
        MatTooltipModule,
        MatBadgeModule,

        MatDialogModule,

        FuseSharedModule,
        FuseSearchBarModule,
        FuseShortcutsModule,
        UtilsModule,
        NgxPermissionsModule,
        SharedModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
    ],
  providers: [
    CookieService
  ],
  exports: [
    ToolbarComponent
  ]
})
export class ToolbarModule {
}
